import { render, staticRenderFns } from "./forms-list.vue?vue&type=template&id=731f856c&scoped=true"
import script from "./forms-list.vue?vue&type=script&lang=js"
export * from "./forms-list.vue?vue&type=script&lang=js"
import style0 from "./forms-list.vue?vue&type=style&index=0&id=731f856c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731f856c",
  null
  
)

export default component.exports